var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { LanguageUtils } from "../../shared/language";
import { t } from "../I18N";

export class DocumentLanguage extends Component {
  render() {
    const { doc } = this.props;

    if (!doc.get('file')) {
      return null;
    }

    if (doc.get('file')) {
      const fileLanguage = doc.getIn(['file', 'language']);
      if (fileLanguage && fileLanguage !== 'other') {var _LanguageUtils$fromIS, _LanguageUtils$fromIS2;
        if (this.props.locale === ((_LanguageUtils$fromIS = LanguageUtils.fromISO639_3(fileLanguage, false)) === null || _LanguageUtils$fromIS === void 0 ? void 0 : _LanguageUtils$fromIS.ISO639_1)) {
          return null;
        }

        return (/*#__PURE__*/
          _jsx("span", { className: "item-type__documentLanguage" }, void 0, /*#__PURE__*/
          _jsx("span", {}, void 0, ((_LanguageUtils$fromIS2 = LanguageUtils.fromISO639_3(fileLanguage, false)) === null || _LanguageUtils$fromIS2 === void 0 ? void 0 : _LanguageUtils$fromIS2.ISO639_1) || fileLanguage)
          ));

      }

      return (/*#__PURE__*/
        _jsx("span", { className: "item-type__documentLanguage" }, void 0, /*#__PURE__*/
        _jsx("span", {}, void 0, t('System', 'Other'))
        ));

    }
  }
}






export const mapStateToProps = ({ locale }) => ({ locale });

export default connect(mapStateToProps)(DocumentLanguage);